var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 9.33594H3.33333C2.59695 9.33594 2 9.93289 2 10.6693V12.6693C2 13.4057 2.59695 14.0026 3.33333 14.0026H12.6667C13.403 14.0026 14 13.4057 14 12.6693V10.6693C14 9.93289 13.403 9.33594 12.6667 9.33594Z",
    stroke: "#5921F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 2.33594H3.33333C2.97971 2.33594 2.64057 2.47641 2.39052 2.72646C2.14048 2.97651 2 3.31565 2 3.66927V5.66927C2 6.02289 2.14048 6.36203 2.39052 6.61208C2.64057 6.86213 2.97971 7.0026 3.33333 7.0026H6.66667",
    stroke: "#5921F2",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3346 7.33333C12.8074 7.33333 14.0013 6.13943 14.0013 4.66667C14.0013 3.19391 12.8074 2 11.3346 2C9.86188 2 8.66797 3.19391 8.66797 4.66667C8.66797 6.13943 9.86188 7.33333 11.3346 7.33333Z",
    stroke: "#5921F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstClass);
export default __webpack_public_path__ + "static/media/FirstClass.7a429e85de3cde8776de6a4665cc9e7a.svg";
export { ForwardRef as ReactComponent };